import { ExpandIconPosition } from 'antd/lib/collapse/Collapse';
import { Collapse as OriginCollapse, ICollapseProps } from './Collapse';
import { CollapsePanel, ICollapsePanelProps } from './Panel';

export type CollapseProps = typeof OriginCollapse & {
  Panel: typeof CollapsePanel;
};

const Collapse = OriginCollapse as CollapseProps;
Collapse.Panel = CollapsePanel;

export type { ExpandIconPosition, ICollapseProps, ICollapsePanelProps };
export { Collapse };
